'use client';

import { useEffect } from 'react';
import { goTo } from '@/lib/base-path';

export default function HomePage() {
  useEffect(() => {
    try {
      const raw = localStorage.getItem('next-robot-ee-auth');
      if (raw) {
        const data = JSON.parse(raw);
        if (data.state?.isAuthenticated) {
          // Жёсткий переход через goTo: location.href не знает basePath, и под
          // подпапкой '/desk' ушёл бы в корень домена, на чужой сайт.
          goTo('/desk');
          return;
        }
      }
    } catch (err) {
      console.warn('[Auth] повреждённый auth-state в localStorage → на логин:', (err as Error).message);
    }
    goTo('/login');
  }, []);

  return (
    <div className="h-[100dvh] flex items-center justify-center gradient-mesh">
      <div className="animate-pulse-soft text-neutral-400 text-sm">Загрузка...</div>
    </div>
  );
}
